// Dynamic styles based on theme - to be used with useThemedStyles.
// Shared by the pick list screen and its dock, overlays and exclusion dialogs.
export const createPickListDetailStyles = ({ ui: { colors, type, space } }) => ({
	page: {
		flex: 1,
		backgroundColor: colors.canvas,
	},
	scrollView: {
		flex: 1,
		backgroundColor: colors.canvas,
	},
	headerActions: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	top: {
		paddingHorizontal: space.gutter,
		paddingBottom: space.gutter,
		gap: space.md,
	},
	bottom: {
		paddingHorizontal: space.gutter,
		paddingTop: space.lg,
		paddingBottom: space.xl,
		gap: space.md,
	},
	card: {
		gap: space.sm,
	},
	cardTitle: {
		...type.sectionTitle,
		color: colors.text,
	},
	cardText: {
		...type.bodySmall,
		color: colors.textSecondary,
		marginBottom: space.xs,
	},
	buttonRow: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: 10,
	},
	flexButton: {
		flex: 1,
	},
	tags: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: space.sm,
	},
	overlay: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: 1000,
		elevation: 1000,
	},
	voiceNext: {
		flex: 10,
		backgroundColor: colors.surface,
		opacity: 0.94,
		alignItems: 'center',
		justifyContent: 'center',
	},
	voiceNextLabel: {
		...type.hero,
		color: colors.text,
	},
	voiceActions: {
		flex: 1,
		minHeight: 64,
		flexDirection: 'row',
	},
	voiceAction: {
		flex: 1,
		alignItems: 'center',
		justifyContent: 'center',
		borderTopWidth: 1,
	},
	voiceActionDisabled: {
		opacity: 0.5,
	},
	voiceActionLabel: {
		...type.button,
	},
	voiceRepeat: {
		backgroundColor: colors.successBg,
		borderColor: colors.successCardBorder,
	},
	voiceRepeatLabel: {
		color: colors.onSuccessBg,
	},
	voicePause: {
		backgroundColor: colors.warningBg,
		borderColor: colors.warningBorder,
	},
	voicePauseLabel: {
		color: colors.warning,
	},
	voiceQuit: {
		backgroundColor: colors.dangerSolid,
		borderColor: colors.dangerSolid,
	},
	voiceQuitLabel: {
		color: colors.onDangerSolid,
	},
	tubSwitchOverlay: {
		backgroundColor: colors.surface,
	},
	tubSwitchBody: {
		flex: 1,
		justifyContent: 'center',
		paddingHorizontal: space.xl,
		paddingVertical: space.xxl,
	},
	tubSwitchContent: {
		width: '100%',
		maxWidth: 480,
		alignSelf: 'center',
	},
	tubSwitchStatus: {
		...type.sectionTitle,
		color: colors.warning,
		textAlign: 'center',
		marginBottom: space.md,
	},
	tubSwitchTitle: {
		...type.hero,
		color: colors.text,
		textAlign: 'center',
	},
	tubSwitchText: {
		...type.body,
		color: colors.textSecondary,
		textAlign: 'center',
		marginTop: space.lg,
		marginBottom: space.xl,
	},
	tubWeightTopRow: {
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'baseline',
		gap: space.sm,
	},
	tubWeightTitle: {
		...type.sectionTitle,
		color: colors.text,
	},
	tubWeightTitlePrompt: {
		color: colors.warning,
	},
	tubWeightValue: {
		...type.sectionTitle,
		color: colors.text,
		flexShrink: 1,
		textAlign: 'right',
	},
	tubWeightSubText: {
		...type.caption,
		color: colors.textSecondary,
		marginTop: -6,
	},
	tubWeightWarningText: {
		...type.caption,
		color: colors.warning,
		marginTop: -6,
	},
	tubWeightActionsRow: {
		flexDirection: 'row',
		gap: space.sm,
	},
	tubWeightAction: {
		flex: 1,
		minHeight: 48,
	},
	dialogContent: {
		paddingTop: space.xs,
		gap: space.sm,
	},
	dialogList: {
		maxHeight: 360,
	},
	dialogEmpty: {
		...type.secondary,
		color: colors.textSecondary,
		paddingVertical: space.sm,
	},
	dialogRow: {
		paddingVertical: space.sm,
		borderBottomWidth: 1,
		borderBottomColor: colors.border,
		gap: space.xs,
	},
	dialogRowControls: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.sm,
	},
	dialogRowTitle: {
		...type.secondarySemibold,
		color: colors.text,
	},
	dialogRowSubTitle: {
		...type.caption,
		color: colors.textSecondary,
		flex: 1,
	},
	dialogEditLabel: {
		...type.caption,
		color: colors.textSecondary,
	},
	dialogInputRow: {
		flexDirection: 'row',
		alignItems: 'center',
	},
});
